import { render, staticRenderFns } from "./priceRadio.vue?vue&type=template&id=08bd49ec&scoped=true"
import script from "./priceRadio.vue?vue&type=script&lang=js"
export * from "./priceRadio.vue?vue&type=script&lang=js"
import style0 from "./priceRadio.vue?vue&type=style&index=0&id=08bd49ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bd49ec",
  null
  
)

export default component.exports